module.exports = "/images/vendor/desiigner-svg/svg/places/temple.svg?08bd58479fc322739d7fe31c091212ac";